import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigateService } from '../../service/navigate.service';
import { NewsService } from '../../service/news.service';

declare var $: any;

@Component({
    selector: 'app-news-detail',
    templateUrl: './news-detail.component.html',
    styleUrls: ['./news-detail.component.styl','../../share/breadcrumb/breadcrumb.component.styl']
})
export class NewsDetailComponent implements OnInit {
    news: NewsModel = new NewsModel({});

    constructor(
        private domSanitizer: DomSanitizer,
        private navigateService: NavigateService,
        private newsService: NewsService
    ){}

    ngOnInit(){
        this.getId();

        setTimeout(() => {
            $('.wrap-box').css('min-height', $(window).height());
        }, 0);
    }

    getId() {
        const id = Number(location.hash.split('/')[3]); //获取id

        //根据id获取页面内容
        this.newsService.getNewsDetail(id).subscribe(res => {
            this.news = new NewsModel(res.data, this.domSanitizer);
        }, err => {
            if (err && err.status === 401) this.navigateService.pushToRoute('/home');
        });
    }
}

class NewsModel{
    public ncId: number;
    public ncTime: string;
    public ncRole: number;
    public ncUrl: string;
    public ncContent: any;
    public ncTitle: string;
    public createTime: number;
    public updateTime: number;

    constructor(data: any, domSanitizer?: DomSanitizer){
        if (data){
            this.ncId = +data.ncId;
            this.ncTime = this.format(data.ncTime);
            this.ncRole = +data.ncRole;
            this.ncTitle = data.ncTitle;
            this.ncContent = domSanitizer && domSanitizer.bypassSecurityTrustHtml(data.ncContent.replace(
                /<img/g,
                '<img style="width:100%; margin: 10px 0;"'
            ));
            this.ncUrl = data.ncUrl;
            this.createTime = data.createTime;
            this.updateTime = data.updateTime;
        }
    }

    format(t){
        const unixTimestamp = new Date(t);
        const mon = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        return mon[unixTimestamp.getMonth()] + ' ' + unixTimestamp.getDate() + ', ' + unixTimestamp.getFullYear();
    }
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/news/news-detail/news-detail.component.ts